import Env from "../environments";

export const devLog = (...args) => {
  if (+Env.DUTY_CAST_EXTENSION_DEBUG_MODE) {
    console.log(...args, Date.now());
  }
}